import { AfterViewInit, Component, OnDestroy, Renderer2 } from '@angular/core';
import { ModalService } from '../../../../components/modal-list/modal-list.service';
import { ModalContactOurExpertComponent } from './modal-contact-our-expert/modal-contact-our-expert.component';
import { WindowRef } from '@spartacus/core';

@Component({
  selector: 'contact-our-experts-hidden',
  templateUrl: './contact-our-experts-hidden.component.html',
  styleUrl: './contact-our-experts-hidden.component.scss',
  standalone: false,
})
export class ContactOurExpertsHiddenComponent implements AfterViewInit, OnDestroy {
  private listener?: () => void;

  constructor(
    private renderer: Renderer2,
    private modalService: ModalService,
    private winRef: WindowRef,
  ) {}

  ngAfterViewInit() {
    if (this.winRef.isBrowser()) {
      this.handlerClick();
    }
  }

  ngOnDestroy() {
    if (this.listener) {
      this.listener();
    }
  }

  handlerClick() {
    this.listener = this.renderer.listen('document', 'click', (event: Event) => {
      const target = event.target as HTMLElement;
      let currentElement: HTMLElement | null = target;

      while (currentElement) {
        if (currentElement.classList.contains('js-open-modal-contact-our-experts')) {
          this.openModalContactOurExperts();
          break;
        }

        currentElement = currentElement.parentElement;
      }
    });
  }

  openModalContactOurExperts() {
    this.modalService.create({
      id: 'modal-contact-our-experts',
      title: 'Contact Our Experts',
      width: 1200,
      component: ModalContactOurExpertComponent,
    });
  }
}
